import type {User} from '@/types/User'

export function devPemissions(user: User, permissions: string[]) {
  if (import.meta.env.PROD) return user

  // Не подмешиваем dev-permissions, когда фронт запущен против stage/prod бэка.
  // Иначе любой реальный юзер получит искусственные админские права в dev-режиме.
  const appEnv = import.meta.env.VITE_APP_ENV
  if (appEnv && appEnv !== 'dev' && appEnv !== 'local') return user

  return {
    ...user,
    permissions: [
      ...user.permissions,
      ...permissions.map(name => ({name, uuid: '', titleRu: '', titleKz: ''})),
    ],
  }
}
